import React from 'react';
import { useFetch } from 'src/hooks/useFetch';
import { Modal } from '..';
import Typography from '@mui/material/Typography';
import { SMS_NG_MODALS } from 'src/utils/constants';

const HabilitarDeshabilitarPausarCampana = (props) => {
  const { open, close, flag, afterConfirm } = props;
  const { fetch } = useFetch();
  const onCloseModal = React.useCallback(() => {
    close();
  }, [close]);
  const confirmHandler = async () => {
    const nuevo_estado =
      flag === SMS_NG_MODALS.HABILITAR_CAMPANA
        ? 'SEND'
        : flag === SMS_NG_MODALS.PAUSAR_CAMPANA
        ? 'PAUSED'
        : 'CANCEL';
    await fetch(`/sms-ng/campanas/${props.data.id}`, {
      method: 'PATCH',
      data: { estado: nuevo_estado },
    });
    afterConfirm();
    close();
  };
  return (
    <Modal
      title={
        flag === SMS_NG_MODALS.HABILITAR_CAMPANA
          ? `Habilitar Campaña`
          : flag === SMS_NG_MODALS.PAUSAR_CAMPANA
          ? 'Pausar Campaña'
          : 'Cancelar Campaña'
      }
      content={
        <>
          <Typography>¿Estás seguro de efectuar este cambio? </Typography>
        </>
      }
      open={open}
      close={onCloseModal}
      showConfirmButton={true}
      onConfirm={confirmHandler}
    />
  );
};

export default HabilitarDeshabilitarPausarCampana;
/*  */
